import styled from 'styled-components';
import { Radio } from 'antd';

export const AddOrRemoveRadioGroup = styled(Radio.Group)`
  padding: 16px 8px;
  width: 100%;
  text-align: center;

  .add-or-remove-radio {
    padding: 8px;
    max-width: 200px;
    width: 100%;
    height: 100%;

    svg {
      margin: 8px;
    }

    > span {
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.colors.primary};
      font-size: ${({ theme }) => theme.fontSizes.large};
    }

    p {
      opacity: 0.8;
      color: ${({ theme }) => theme.colors.text};
      font-size: ${({ theme }) => theme.fontSizes.small};
      margin: 0;
    }
  }

  .remove-radio {
    > span {
      color: ${({ theme }) => theme.colors.red};
    }
  }
`;

export const ValidationStepContainer = styled.div<{ isAdd?: boolean }>`
  padding: 24px;
  text-align: center;

  .validation-exclamation-circle {
    font-size: 2rem;
    font-weight: bold;
    padding: 4px 8px;
    color: ${({ theme, isAdd }) =>
      isAdd ? theme.colors.green : theme.colors.red};
  }

  .validation-paragraph {
    color: ${({ theme }) => theme.colors.text};
    margin: 0 auto;
    margin-top: 8px;
    font-size: ${({ theme }) => theme.fontSizes.large};
    max-width: 280px;
  }
`;
